import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why you should talk about engineering salaries",
  "description": "",
  "published": "2020-02-21T00:00:00.000Z",
  "redirect_from": ["/blog/why-you-should-talk-about-engineering-salaries/swizec/9332"],
  "categories": "Opinions, Personal",
  "hero": "./img/techletter.app-screenshot-1582305280005.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Twitter went abuzz with engineers sharing their salaries. Then everything turned to shit.`}</p>
    <p>{`Why are all these rich fucks complaining about not being rich enough?? TONE DEAF!`}</p>
    <p>{`I'm on food stamps and these spoiled Silicon Valley engineers over here sipping $12 lattes wearing $100 allbirds and complaining about money on their $1000 iphone.`}</p>
    <p><img parentName="p" {...{
        "src": "/521338db4aea9f8748f13c1a6a843674/media-3owypkSIpM8xw6p7W0-giphy.gif",
        "alt": "ugh giphy"
      }}></img></p>
    <p>{`And that person is right. Engineers `}<em parentName="p">{`are`}</em>{` spoiled. We live in a time where our skills are highly sought after, deliver heaps of value, and take lots of work to acquire.`}</p>
    <p>{`Time to get paid, baby! Ka-ching`}</p>
    <p>{`No seriously, that's `}<em parentName="p">{`the`}</em>{` trifecta of making money:`}</p>
    <ol>
      <li parentName="ol">{`Skill that's hard to acquire`}</li>
      <li parentName="ol">{`Skill that delivers lots of value`}</li>
      <li parentName="ol">{`Skill that everyone needs`}</li>
    </ol>
    <p>{`Add to that a fast growing market and 🤑`}</p>
    <h2 {...{
      "id": "but-mention-money-and-everyone-loses-their-shit"
    }}>{`But mention money and everyone loses their shit`}</h2>
    <p>{`Engineers are weird when it comes to money.`}</p>
    <p>{`You're supposed to love coding for the love of the coding. You're supposed to give most of your work away for free. You're supposed to be ashamed about how much money you make.`}</p>
    <p>{`Fuck that.`}</p>
    <p>{`Ever seen a lawyer give their work away for free? They won't even comp you a pencil.`}{`[`}{`1] What about a doctor? Or a dentist? Fortune500 exec?`}</p>
    <p><em parentName="p">{`Those`}</em>{` are the folks making 6 figures. You need to stop thinking like a $10/hour barista, my friend.`}</p>
    <p>{`But please do contribute to open source. The fate of every multi-billion dollar tech unicorn rests on your free code.`}</p>
    <p><img parentName="p" {...{
        "src": "/d038633c4253177c73d7c2e0a8d6084a/media-S7RAioXMRs8b6-giphy.gif",
        "alt": "awkward giphy"
      }}></img></p>
    <h2 {...{
      "id": "consider-your-value"
    }}>{`Consider your value`}</h2>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1228825341579448320"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "42.152466367713004%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'169\\'%20viewBox=\\'0%200%20400%20169\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2017C6%2027%2020%2051%2037%2043c4-2%204-4%201-5-5-1-3-5%202-5%206%200%205-10-2-15-5-3-11-4-15-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0f9dcf471416ac8307861bbbdc1ba82a/ca0a1/techletter.app-screenshot-1582305280005.webp 223w", "/static/0f9dcf471416ac8307861bbbdc1ba82a/75680/techletter.app-screenshot-1582305280005.webp 445w", "/static/0f9dcf471416ac8307861bbbdc1ba82a/0ba47/techletter.app-screenshot-1582305280005.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0f9dcf471416ac8307861bbbdc1ba82a/e92b6/techletter.app-screenshot-1582305280005.png 223w", "/static/0f9dcf471416ac8307861bbbdc1ba82a/e66bf/techletter.app-screenshot-1582305280005.png 445w", "/static/0f9dcf471416ac8307861bbbdc1ba82a/6af66/techletter.app-screenshot-1582305280005.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0f9dcf471416ac8307861bbbdc1ba82a/6af66/techletter.app-screenshot-1582305280005.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The mindset shift I urge you to consider is this: `}<strong parentName="p">{`It doesn't matter how hard or how much `}<em parentName="strong">{`you`}</em>{` work, it only matters how much value `}<em parentName="strong">{`they`}</em>{` get.`}</strong></p>
    <p>{`I think that's why engineers are squeamish about salary.`}</p>
    <p>{`We think we're overpaid. We think our work's too easy. We come from backgrounds where hard work is a virtue, physical labor is king, `}<em parentName="p">{`doing`}</em>{` stuff is the norm, and your boss is a jerk.`}</p>
    <p>{`And all we do is sit there and type and think.`}</p>
    <p><strong parentName="p">{`But YOU deliver tons of value`}</strong>{`. Tons.`}</p>
    <p>{`Google, for example, makes `}<a parentName="p" {...{
        "href": "https://9to5google.com/2019/10/28/alphabet-q3-2019-earnings/"
      }}>{`\\`}{`\\`}{`\\`}{`$1.3 `}<em parentName="a">{`million`}</em>{` dollars revenue per employee`}</a>{`. Some $300k of that is pure profit.`}</p>
    <p>{`You don't even have to work for Google. Any profitable company will do. Hell, even unprofitable companies get tons of value from you in investments and future returns on your work.`}</p>
    <p>{`If your company bleeds money and not because they're betting on VC rocketship stuff ... you should reconsider 😅`}</p>
    <h2 {...{
      "id": "why-sharing-salaries-helps-everyone"
    }}>{`Why sharing salaries helps everyone`}</h2>
    <p>{`Ok so you're being paid for value, your value is massive, and what's the point of sharing salaries?`}</p>
    <p>{`Sharing your salary in public might hurt your negotiating position, this is true. They're gonna say `}<em parentName="p">{`"Yo you did this work for $X, why you want $Y now?"`}</em></p>
    <p>{`You are talking to a wage slave. Stop. Find someone else. Change the conversation.`}</p>
    <p>{`It doesn't matter that you did similar work for $X. The new company is bigger, more profitable, and has more painful more expensive problems. You are here to help and `}<strong parentName="p">{`deliver `}<em parentName="strong">{`more`}</em>{` value`}</strong>{`.`}</p>
    <p>{`That's why you're getting more.`}</p>
    <p>{`And sharing your income could make people envious, jealous, feel bad about themselves, etc. That's the short term.`}</p>
    <p>{`Long term those people will learn from you. They'll be inspired. They're going to change their lives.`}</p>
    <p><em parentName="p">{`YOU`}</em>{` can show them what's possible.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1228697056002351104"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "118.38565022421523%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'474\\'%20viewBox=\\'0%200%20400%20474\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2017c-13%207-8%2027%207%2027%207%200%2013-4%208-6l-3-1c0-2%201-4%204-4%207%200%207-8-1-14-4-4-9-5-15-2m64%20364c0%204-2%206-2%201%200-2%200-3-2-3s-2%200-2%203%200%204-3%202v-2c2%200%202-2%200-3s-5%202-3%204c1%202%201%202-1%202-3%200-3-3%200-5%201-1%201-1-1-1-1%200-2%201-2%204-1%204-1%204%2013%204%2012-1%2012-1%2010-2v-6l-1%201h-2c0-2-2-1-2%201l2%203-1%201c-1%200-2-1-2-4l-1-4v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9f137efa3cf8a2b967b871ba114eb991/ca0a1/techletter.app-screenshot-1582305280198.webp 223w", "/static/9f137efa3cf8a2b967b871ba114eb991/75680/techletter.app-screenshot-1582305280198.webp 445w", "/static/9f137efa3cf8a2b967b871ba114eb991/0ba47/techletter.app-screenshot-1582305280198.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9f137efa3cf8a2b967b871ba114eb991/e92b6/techletter.app-screenshot-1582305280198.png 223w", "/static/9f137efa3cf8a2b967b871ba114eb991/e66bf/techletter.app-screenshot-1582305280198.png 445w", "/static/9f137efa3cf8a2b967b871ba114eb991/6af66/techletter.app-screenshot-1582305280198.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9f137efa3cf8a2b967b871ba114eb991/6af66/techletter.app-screenshot-1582305280198.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`HackerNews comments 10 years ago made me look at my income and think `}<em parentName="p">{`"Why the fuck am I working for peanuts when folks just like me in Silicon Valley are making bank? This shit whack"`}</em></p>
    <p>{`I moved. Now I put more into savings every year than my just-as-talented peers back home make in total salary. At least the ones that aren't freelancing remotely for US companies.`}</p>
    <p>{`Without folks sharing how much they make, I'd still be stuck building websites for $5/hour.`}</p>
    <p>{`Thank you kind internet strangers.`}</p>
    <h2 {...{
      "id": "in-conclusion"
    }}>{`In conclusion`}</h2>
    <p>{`Tell your friends how much you make. Figure out together how you all can make more.`}</p>
    <p>{`Just a $2000 salary increase can compound into $178,000 of lifetime savings and that's kinda crazy. `}<a parentName="p" {...{
        "href": "https://www.investor.gov/additional-resources/free-financial-planning-tools/compound-interest-calculator"
      }}>{`source`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4ccc5650a96b1d7ba8496d0def3218c1/5a190/Zgnkf3y.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "84.75336322869954%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'339\\'%20viewBox=\\'0%200%20400%20339\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20170v169h401V0H0v170M248%205c-2%200-1%205%201%206v4c1%200%203-1%203-3l2-1%202%201c2%200%203%200%202%202l4%201%204-1-2-1-2-1c1-1%200-2-1-3s-2-2-1-3c1-3-2-2-4%201s-2%203-2%201c0-3-3-5-6-3M10%20208v122h378V86H10v122m364-85v2c1%201-4%206-6%206l-3%202c-1%204-5%206-9%207l-1%202c0%201-5%206-7%206l-5%204c-3%203-4%204-5%203l-3%202c-1%203-5%206-7%206l-5%204c-2%202-4%203-5%202-1%200-2%200-3%202s-4%205-6%205-3%201-5%203l-6%203c-2%200-3%201-3%202l-6%204-4%201c0%202-3%204-6%204l-4%202c0%201-6%204-7%203l-4%203c-2%202-3%202-5%202-3-1-3-1-4%201%200%202-4%204-7%203-1%200-2%200-3%202l-5%203-6%202c-2%202-3%202-5%202-2-1-3-1-4%201s-3%202-5%202l-5%202c-1%202-6%203-7%202%200-1-1-1-3%201s-4%203-6%202c-1-1-2%200-3%201-1%202-3%202-5%202l-5%202-6%201-5%202-5%201-5%202-5%201h-4c-1%202-5%203-7%202-1-1-2%200-4%201-2%202-3%202-6%202-2-1-3-1-3%201l-5%201h-6c-1%202-4%203-6%202-1-1-2-1-3%201l-5%201c-3-1-4%200-5%201l-6%201c-3-1-4-1-5%201l-5%201c-1-1-4%200-6%201h-4c-2-1-4%200-4%202l2%202%202-1c0-1%205-2%206-1%202%201%203%201%204-1l5-1h5l5-1%206-1%204-1h4c1-1%207-2%208-1l3-1%206-1h3c1-1%207-2%208-1l3-1%206-1h3c1-1%207-2%208-1l3-1%206-1h3l4-1h6l5-1%205-1%205-1h5l5-1%206-1%204-1h5l15-3h5l6-1%205-1c2-1%2013-3%2016-2l4-1%204-1h5l15-2%205-1%2015-2%205-1%2015-2%205-1c4-2%207-2%207-1%201%201%202%200%204-1l5-1h4c1-1%205-2%207-1h2c2-2%200-3-4-2l-5%201h-3l-16%202-5%201-5%201-6%201-5%201h-4l-4%201-7%201-6%201h-3l-4%201-7%201-6%201h-3l-4%201h-5c-4%202-7%202-7%201-1-1-2%200-3%201l-6%201h-4c-4%202-7%202-8%201%200-1-1-1-2%201l-5%201h-5c-4%202-7%202-7%201-1-1-2%200-3%201l-6%201h-4c-4%202-7%202-7%201-1-1-2%200-4%201l-5%201h-5c-1%201-6%202-14%202l-6%201-6%201c-2-2%202-4%206-4l5-2%205-1%206-2%204-2%205-1%204-2%207-2c2-1%204-2%206-1l3-1%205-3%206-2%205-2c1%201%202%200%203-1%202-2%206-4%208-3l2-1c2-2%205-4%208-4l4-2%205-2%203-1%207-5%205-2c2-2%203-2%206-2l2-2c2-2%206-5%208-4l2-1c0-2%205-5%208-5l3-2c0-2%205-5%207-5l4-3c3-3%205-4%206-3%201%200%202%200%203-2%201-3%205-6%207-6l4-3c2-3%204-4%206-4l2-1c0-2%205-7%208-7l2-3c2-2%206-6%208-6l2-1c0-2%205-7%208-8l2-3c-1-2-4-3-5-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4ccc5650a96b1d7ba8496d0def3218c1/ca0a1/Zgnkf3y.webp 223w", "/static/4ccc5650a96b1d7ba8496d0def3218c1/75680/Zgnkf3y.webp 445w", "/static/4ccc5650a96b1d7ba8496d0def3218c1/d00b9/Zgnkf3y.webp 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4ccc5650a96b1d7ba8496d0def3218c1/e92b6/Zgnkf3y.png 223w", "/static/4ccc5650a96b1d7ba8496d0def3218c1/e66bf/Zgnkf3y.png 445w", "/static/4ccc5650a96b1d7ba8496d0def3218c1/5a190/Zgnkf3y.png 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/4ccc5650a96b1d7ba8496d0def3218c1/5a190/Zgnkf3y.png",
              "alt": "Zgnkf3y",
              "title": "Zgnkf3y",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Happy Friday ❤️`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: you can see the full spreadsheet of salaries compiled from tweets here: `}{`[`}<a parentName="p" {...{
        "href": "https://docs.google.com/spreadsheets/d/1-xIgk7Mw1S5DXTZSbKBgxlsQAn7XGIu7Mfy72lSVHKk/edit#gid=129993618"
      }}>{`click`}</a>{`]. Data is kinda messy but very fascinating`}</p>
    <p>{`[`}{`1] when you work with lawyers you'll sometimes notice an invoice for thousands of dollars of their time ... oh and $20 for ink and printing`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      